/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_TitleInputs */

const cs_viewings_title = /** @type {(inputs: Viewings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídky`)
};

const en_viewings_title = /** @type {(inputs: Viewings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewings`)
};

/**
* | output |
* | --- |
* | "Viewings" |
*
* @param {Viewings_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_title = /** @type {((inputs?: Viewings_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_title(inputs)
	return cs_viewings_title(inputs)
});